import axios from "axios";
import React, { useState } from "react";
import styled from "styled-components";
import { useEffect, useContext } from "react";
import { Link, useLocation } from "react-router-dom";
import authContext from "../store/authContext";
const Search = () => {
	// const location = useLocation();
	const stx = useContext(authContext);
	console.log(stx.inputItem);
	// const data = location.state.data;
	// console.log(data);
	const [searchEle, setSearchElement] = useState([]);
	// 324857

	useEffect(() => {
		axios
			.get(
				`https://api.themoviedb.org/3/search/multi?api_key=0bcafd5b459497ec53d81e9fc940f86d&language=en-US&query=${stx.inputItem}&page=1&include_adult=false`
			)
			.then((res) => {
				setSearchElement([...res.data.results]);
			});
	}, [stx.inputItem]);
	return (
		<Content>
			{searchEle.map((ele, index) => {
				console.log(ele);
				return (
					<Link
						to={"/detail"}
						state={{
							data: searchEle.filter((info) => {
								return info.id === ele.id;
							}),
						}}
						key={ele.id}>
						<Wrap>
							<img
								src={`https://image.tmdb.org/t/p/w300/${ele.poster_path}`}
								alt={ele.original_title}
							/>
						</Wrap>
					</Link>
				);
			})}
		</Content>
	);
};

export default Search;

const Content = styled.div`
	margin: 20px 0px;
	display: grid;
	grid-template-columns: repeat(8, minmax(0, 1fr));
	grid-template-rows: repeat(auto-fit, 1fr);
	grid-gap: 25px;
	position: relative;
	@media (max-width: 1024px) {
		grid-template-columns: repeat(6, minmax(100px, 1fr));
	}
	@media (max-width: 768px) {
		grid-template-columns: repeat(5, minmax(100px, 1fr));
	}
	@media (max-width: 648px) {
		grid-template-columns: repeat(4, minmax(85px, 1fr));
	}
	@media (max-width: 500px) {
		grid-template-columns: repeat(4, minmax(70px, 1fr));
	}

	@media (max-width: 376px) {
		justify-content: center;
		grid-template-columns: repeat(4, minmax(50px, 1fr));
	}
`;

const Wrap = styled.div`
	height: 100%;
	cursor: pointer;
	box-shadow: rgb(0 0 0 /69%) 0px 26px 30px -10px,
		rgb(0 0 0 /73%) 0px 16px 10px -10px;
	// border: 2px solid rgba(249, 249, 249, 0.1);
	transition: all 250ms cubic-bezier(0.25, 0.46, 0.45, 0.94) 0s;
	border-radius: 10px;
	img {
		height: 100%;
		width: 100%;
		object-fit: cover;
		border-radius: 10px;
	}
	&:before {
		position: absolute;
		content: "${(props) => props.rating}";
		border-radius: 50%;
		background-color: #081c22;
		width: 35px;
		height: 35px;
		font-size: 10px;
		// text-align: center;
		color: #fff;
		display: flex;
		justify-content: center;
		align-items: center;
		// padding: 1px;
		bottom: -7px;
		right: -7px;
	}
	&:hover {
		transform: scale(1.05);
		box-shadow: rgb(0 0 0 /80%) 0px 40px 58px -16px,
			rgb(0 0 0 /72%) 0px 30px 22px -10px;
		border-color: rgba(249, 249, 249, 0.8);
	}
`;
